
import { mapGetters, mapState } from "vuex";

import chooseUserLocationDialog from "../dialogs/choose-user-location-dialog.vue";
export default {
  components: { chooseUserLocationDialog },
  data() {
    return {
      showChooseUserLocationDialog: false
    };
  },
  mounted() {
    if (
      (!this.isDeliveryAddressSelected && this.isHomeDelivery) ||
      (!this.cart?.delivery_address?.house_number && this.isHomeDelivery)
    ) {
      this.showChooseUserLocationDialog = true;
      return;
    }
  },
  computed: {
    ...mapGetters("order", ["isDeliveryAddressSelected", "isHomeDelivery"]),
    ...mapState("order", ["cart"])
  }
};
